export const COST_MODE = {
    WATT: 'w',
    MONEY: '$'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/cost/cost.constant.js